// Mock data for 3D Printzkart website

export const companyInfo = {
  name: "3D Printzkart",
  tagline: "Best 3D Printing Service in Bangalore",
  phone: "+91 6360283627",
  email: "orders@3dprintzkart.com",
  tollFree: "+91 6360283627",
  address: "75, Ground Floor, Near Saanvi Sagar, JP Nagar 4th Phase, Dollar Layout, Phase 4, J. P. Nagar, Bengaluru, Karnataka 560078",
  gst: "29AABCP1234A1ZA",
  workingHours: "Mon - Sat: 10:00 AM to 6:00 PM",
  facebook: "https://www.facebook.com/people/3DPrintzkart/100063732472328/",
  instagram: "https://www.instagram.com/printzkart/",
  linkedin: "https://www.linkedin.com/company/3d-printzkart/",
  whatsapp: "https://wa.me/916360283627?text=Hi%2C%20I%20would%20like%20to%20get%20a%20quote%20for%203D%20printing",
  teams: "https://teams.microsoft.com/l/meetup-join",
  calendly: "https://calendly.com/3dprintzkart",
  googleMeet: "https://meet.google.com/3dprintzkart",
};

export const heroData = {
  subtitle: "Best 3D Printing Service in Bangalore",
  title: "Empowering Innovation Additively.",
  description:
    "3D Printzkart partners with OEMs, ODMs, startups, and MSMEs to deliver high-precision prototypes and engineering-grade parts using FDM, SLA, SLS, and DMLS technologies. From design and validation to rapid prototyping and production, we turn ideas into manufacturable products.",
  ctaText: "Build With Us",
  ctaLink: "#contact",
};

export const stats = [
  { value: 2770, suffix: "+", label: "3D Prints Delivered", sublabel: "Across 20+ Countries" },
  { value: 195, suffix: "+", label: "Design-to-Build Projects", sublabel: "Production Ready" },
  { value: 4, suffix: "", label: "Technologies", sublabel: "FDM + SLA + SLS + DMLS" },
  { value: 293, suffix: "+", label: "Satisfied Customers", sublabel: "Dreams Made Possible" },
  { value: 15, suffix: "+", label: "Materials Available", sublabel: "With R&D Window" },
  { value: 20, suffix: "+", label: "3D Printer Farm", sublabel: "Cloud Batch Production" },
];

export const aboutData = {
  subtitle: "WHY WE ARE UNIQUE",
  title: "About 3D Printzkart",
  description:
    "Founded in 2018, 3D Printzkart began in a garage with a simple goal — help innovators solve manufacturing challenges faster. Today, we have grown into a full-scale additive manufacturing print farm in Bangalore, delivering reliable, production-grade solutions. Over the years, we have supported startups, MSMEs, large enterprises, and research institutions, providing precision prototypes, functional components, and rapid production parts. With FDM, SLA, SLS, and DMLS technologies under one roof, we select the right process for each application to ensure quality, speed, and cost-effective results. From concept to functional deployment, our mission remains the same: deliver impactful additive manufacturing solutions that help ideas reach the market faster.",
  yearsExperience: 10,
  highlight: "WHY CHOOSE US",
  highlightDesc:
    "Years of Experience",
};

export const services = [
  {
    id: 1,
    icon: "Layers",
    title: "Fused Deposition Modelling (FDM)",
    shortDesc:
      "Cost-effective functional prototypes for strength and display using PLA, ABS, TPU, and carbon-reinforced filaments. Our 20+ printer farm delivers batch production at scale.",
    link: "/services/fdm",
  },
  {
    id: 2,
    icon: "Gem",
    title: "Stereolithography (SLA)",
    shortDesc:
      "High-precision resin printing for detailed prototypes, jewelry patterns, and medical devices. Supports Tough, Clear, and Castable Resins for diverse applications.",
    link: "/services/sla",
  },
  {
    id: 3,
    icon: "Zap",
    title: "Selective Laser Sintering (SLS)",
    shortDesc:
      "Industrial-grade parts in Nylon for production-ready components. The most durable additive manufacturing technology.",
    link: "/services/sls",
  },
  {
    id: 4,
    icon: "Lightbulb",
    title: "Product Development",
    shortDesc:
      "End-to-end product design from concept sketching to functional prototyping. Our team combines creative design with DFAM principles for manufacturing excellence.",
    link: "/services/product-development",
  },
  {
    id: 5,
    icon: "RefreshCw",
    title: "Reverse Engineering",
    shortDesc:
      "We recreate existing parts into accurate CAD models using precision geometric measurements, ideal for legacy or undocumented components. 3D scanning is used for complex geometries to ensure precise digital reconstruction for redesign or manufacturing.",
    link: "/services/reverse-engineering",
  },
];

export const principles = [
  {
    number: "01",
    title: "Ethics & Security",
    description:
      "We bind and follow NDAs with full compliance. All shared data is stored securely with enterprise-grade encryption and strict access controls.",
  },
  {
    number: "02",
    title: "Lean Manufacturing",
    description:
      "Optimized print queue with guaranteed best lead times. Every print job is prioritized for efficiency, reducing waste and maximizing output quality.",
  },
  {
    number: "03",
    title: "Precision Engineering",
    description:
      "Best-in-class fit and assembly tolerances based on functionality. We implement DFAM-based hybrid manufacturing combining FDM, SLA, and SLS technologies.",
  },
  {
    number: "04",
    title: "Quality Assurance",
    description:
      "Every part undergoes rigorous quality checks before delivery. Our multi-stage inspection process ensures dimensional accuracy and surface finish meet your specifications.",
  },
];

export const whyChooseUs = {
  title: "WHY CHOOSE US",
  description:
    "Commodity print farms just hit Start on an STL file. We integrate directly into your R&D and supply chain, providing DFAM-optimized manufacturing that scales seamlessly from functional prototyping to end-use batch production.",
  points: [
    {
      title: "Hybrid Manufacturing Intelligence (DFAM)",
      description: "We analyze your mechanical load and environmental requirements to deploy the optimal combination of FDM, SLA, SLS, and DLMS. Parts engineered for actual strength, assembly tolerances, and field functionality.",
    },
    {
      title: "Airtight IP Protection & Ethics",
      description: "Your CAD files are your most valuable assets. We operate under strict NDAs and rigorous data compliance protocols. Your proprietary designs are securely stored, processed, and protected.",
    },
    {
      title: "Cloud-Optimized Fleet (20+ Industrial Nodes)",
      description: "Our synchronized local print farm guarantees a lean, optimized queue with predictable lead times. From urgent prototypes to batches of 150 IP65 enclosures, our infrastructure scales instantly.",
    },
    {
      title: "Advanced Material R&D",
      description: "15+ industrial-grade materials including Carbon-Reinforced Filaments, TPU, Castable Resins, and Nylon for rigorous field testing and deployment.",
    },
  ],
};

export const documentsData = [
  { title: "Company Portfolio", format: "PDF", icon: "FileText", link: "/company_portfolio.pdf" },
  { title: "Company Documents", format: "ZIP", icon: "FolderArchive", link: "/company_docs.zip" },
];


export const projects = [
  {
    id: 1,
    title: "Precision Threads",
    category: "Medical Devices",
    description: "High Precision threads of Class H and Class G were 3D Printed for medical devices in SLA technology",
    image: "/projects/image83.png",
  },
  {
    id: 2,
    title: "CCTV functional Proto",
    category: "Electronics",
    description: "CCTV enclosure was designed to fit a custom circuitry, the product was tested in field for month and electronics were proof checked",
    image: "/projects/image84.png",
  },
  {
    id: 3,
    title: "Vintage Car Parts",
    category: "Automotive",
    description: "Gone re the days, of an ambassador? No! not anymore, we restored the Knobs for this customer by reverse engineering the older knob and we keep printing in bulk to this day",
    image: "/projects/image85.png",
  },
  {
    id: 4,
    title: "Transtibial Prosthetic BK socket",
    category: "Healthcare",
    description: "In collaboration with Mobility India, we have developed and patented this technology, where we manufacture, assistive devices additively! This was done in PP material, from PPPrintGmBH",
    image: "/projects/image120.png",
  },
  {
    id: 5,
    title: "SMO- Orthotic for Cleft Foot",
    category: "Medical",
    description: "Digitally Transformed and 3D Printed with PP material, Super mellular Orthosis",
    image: "/projects/image116.png",
  },
  {
    id: 6,
    title: "Rafael Scaled Model",
    category: "Scale Models",
    description: "Rafael Scale model FDM 3D Printed and Post production",
    image: "/projects/image115.png",
  },
  {
    id: 7,
    title: "Interior Design",
    category: "Architecture",
    description: "Interior Designs for model of Bed.",
    image: "/projects/image117.png",
  },
  {
    id: 8,
    title: "Squid Game Mask",
    category: "Cosplay",
    description: "Cos play , mask for Squid game.",
    image: "/projects/image119.png",
  },
  {
    id: 9,
    title: "Battery pack Enclosures",
    category: "Batch Production",
    description: "Batch Production of 50 Pieces were done for an OEM and was deployed to Field. From Design to Print , with a lead time of 15 days",
    image: "/projects/image143.png",
  },
  {
    id: 10,
    title: "Industrial Plant Scaled model",
    category: "Industrial",
    description: "A Cement plant mockup was made from Design to Print. The input were a few realtime pics which the team was able to make a great Display piece",
    image: "/projects/image98.png",
  },
  {
    id: 11,
    title: "BMRCL Scaled model",
    category: "Scale Models",
    description: "A portion of metro rail was made as a souvenir, the customer was only a Hand sketch, FDM and SLA was used together for a turnaround time of 3 hours.",
    image: "/projects/image142.png",
  },
  {
    id: 12,
    title: "IoT device",
    category: "Electronics",
    description: "A functional IoT device was developed with only PCB in hand, the part was 3D Printed and batch produced with entire in FDM technology",
    image: "/projects/image108.png",
  },
  {
    id: 13,
    title: "Bird Eye view-Temple Complex",
    category: "Architectural",
    description: "A bird eyeview was 3D Printed from a Given Model from Rhino Software, the STL was exported and errors were fixed and 3D Printed.",
    image: "/projects/image132.png",
  },
  {
    id: 14,
    title: "Jewellery Mockup",
    category: "Jewelry",
    description: "Jewelery design would be enhanced with 3D Printing in SLA -Castable Resins, that can be used for investment casting as patterns",
    image: "/projects/image121.png",
  },
  {
    id: 15,
    title: "Landscaping Props",
    category: "Batch Production",
    description: "150 Pieces- Props done in batch production for landscaping. Turn around time was 2 days in SLA and FDM 3D Printer",
    image: "/projects/image141.png",
  },
  {
    id: 16,
    title: "Super Heroes",
    category: "Art",
    description: "Yes! Superheroes have Risen up from our SLA 3D Printers, any Character can be done , either with or without design.",
    image: "/projects/image142.png",
  },
  {
    id: 17,
    title: "Humanoid Body",
    category: "Robotics",
    description: "3D Printing, Life size is a reality, this outer body was 3D Printed for 12 days and Got finally everything to one piece with proper DFAM",
    image: "/projects/image152.png",
  },
  {
    id: 18,
    title: "Spider man Mask Cos play",
    category: "Cosplay",
    description: "Cos play accessories are a great market and we have left no stone unturned, the design was supplied and the Print came great in FDM",
    image: "/projects/image153.png",
  },
  {
    id: 19,
    title: "Cranial Helmets",
    category: "Medical",
    description: "The human cause of Cerebral Palsy was addressed with Digital Transformation. The patient skull was scanned and Helmet was designed and 3D printed in TPU",
    image: "/projects/image143.png",
  },
  {
    id: 20,
    title: "IP 65 Enclosures",
    category: "Electronics",
    description: "The Part was completely, finished and Mirror finished, with the Gasket 3D Printed in TPU. The material Combo was perfect with FDM",
    image: "/projects/image144.png",
  },
  {
    id: 21,
    title: "Functional Spares",
    category: "Industrial",
    description: "Precsion Gears made for a complex mechanism. FDM offered great precision. Turna round time was 3 hours",
    image: "/projects/image145.png",
  },
  {
    id: 22,
    title: "Nasa Mars Rover Miniature",
    category: "Scale Models",
    description: "Exhibited at HN Science Center, the product was completely 3D Printed and Post Processed in total 150 parts and 24 days 15 machines",
    image: "/projects/image121.png",
  },
  {
    id: 23,
    title: "3D Printed Control Unit Enclosure",
    category: "Electronics",
    description: "Precision. Durability. Engineering Excellence.",
    image: "/projects/image82.png",
  },
  {
    id: 24,
    title: "3D Printed Mannequin Head",
    category: "Art & Design",
    description: "Precision. Art. Innovation.",
    image: "/projects/image120.png",
  },
  {
    id: 25,
    title: "3D Printed Automotive Intake Manifold",
    category: "Automotive",
    description: "Production-Ready Solutions",
    image: "/projects/image116.png",
  },
  {
    id: 26,
    title: "Broken → Built → Back in Action",
    category: "Part Restoration",
    description: "Reverse engineering and 3D printing of replacement parts",
    image: "/projects/image117.png",
  },
  {
    id: 27,
    title: "3D Printed Acoustic Spare Parts",
    category: "Audio",
    description: "Precision from the First Pour.",
    image: "/projects/image119.png",
  },
  {
    id: 28,
    title: "Precision 3D Printed Electronics Enclosure",
    category: "Electronics",
    description: "Small Form, Big Precision.",
    image: "/projects/image143.png",
  },
  {
    id: 29,
    title: "3D Printed Jigs & Fixtures",
    category: "Industrial Tooling",
    description: "Smarter Manufacturing Starts Here",
    image: "/projects/image120.png",
  },
  {
    id: 30,
    title: "3D Printed Mixed Component Set",
    category: "Multi-Component",
    description: "Prototypes to Production Parts, All in One Order.",
    image: "/projects/image163.png",
  },
];

export const trustedBy = [
  "Byju's", "Panasonic", "Larsen & Toubro", "Elecnovo", 
  "Saankhya Labs", "KYB Corporation", "Tanishq", "HCL", 
  "TVS", "Herman Miller", "ITC", "Mahindra", 
  "Ultrahuman", "Bradken", "Intessence",
];

export const blogPosts = [
  {
    id: 1,
    date: "15",
    month: "Jun",
    year: "2025",
    author: "3D Printzkart",
    category: "Technology",
    title: "FDM vs SLA vs SLS: Choosing the Right 3D Printing Technology",
    excerpt: "A comprehensive guide to selecting the best additive manufacturing technology for your project needs in Bangalore.",
    image: "https://images.unsplash.com/photo-1642969164999-979483e21601?w=400&h=270&fit=crop",
  },
  {
    id: 2,
    date: "08",
    month: "Jun",
    year: "2025",
    author: "3D Printzkart",
    category: "Industry",
    title: "How 3D Printing is Revolutionizing Medical Device Manufacturing",
    excerpt: "Exploring the impact of additive manufacturing on prosthetics, implants, and surgical tools in India's healthcare sector.",
    image: "https://images.unsplash.com/photo-1611505908502-5b67e53e3a76?w=400&h=270&fit=crop",
  },
  {
    id: 3,
    date: "01",
    month: "Jun",
    year: "2025",
    author: "3D Printzkart",
    category: "Innovation",
    title: "Rapid Prototyping in Bangalore: From Concept to Product in 48 Hours",
    excerpt: "How startups and enterprises in Bangalore leverage 3D printing for faster product development cycles.",
    image: "https://images.unsplash.com/photo-1597765206558-6f4e06954f2f?w=400&h=270&fit=crop",
  },
];

export const navLinks = [
  { label: "Home", href: "#home" },
  {
    label: "Services",
    href: "#services",
    submenu: [
      { label: "FDM Printing", href: "#services" },
      { label: "SLA Printing", href: "#services" },
      { label: "SLS Printing", href: "#services" },
      { label: "Product Development", href: "#services" },
    ],
  },
  { label: "Projects", href: "#projects" },
  { label: "About", href: "#about" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

export const footerData = {
  about:
    "3D Printzkart is Bangalore's leading 3D printing service provider offering FDM, SLA, SLS and DMLS technologies for prototyping, batch production, and custom manufacturing solutions.",
  services: [
    "FDM 3D Printing",
    "SLA 3D Printing",
    "SLS 3D Printing",
    "DMLS Metal Printing",
    "Product Development",
    "Reverse Engineering",
    "Post-Processing",
    "Batch Production",
  ],
  quickLinks: [
    { label: "About Us", href: "#about" },
    { label: "Our Services", href: "#services" },
    { label: "Projects", href: "#projects" },
    { label: "Blog", href: "#blog" },
    { label: "Get a Quote", href: "#contact" },
    { label: "Privacy Policy", href: "#" },
  ],
  socialLinks: [
    { platform: "Facebook", url: "https://www.facebook.com/people/3DPrintzkart/100063732472328/" },
    { platform: "Instagram", url: "https://www.instagram.com/printzkart/" },
    { platform: "Linkedin", url: "https://www.linkedin.com/company/3d-printzkart/" },
  ],
};

export const customerRating = {
  score: 4.9,
  label: "Customer Rating",
  review: "Full reviews at Google Business",
};

export const googleReviews = {
  score: 4.9,
  count: 312,
  label: "Google Reviews",
  url: "https://www.google.com/maps/search/?api=1&query=3D%20Printzkart%20JP%20Nagar%20Bangalore",
  embedUrl: "https://maps.google.com/maps?q=3D%20Printzkart%2C%2075%20Ground%20Floor%2C%20JP%20Nagar%204th%20Phase%2C%20Bangalore%20560078&z=15&ie=UTF8&iwloc=&output=embed",
};

export const testimonials = [
  {
    name: "Prisha U.S",
    role: "Jewelry Designer, Bengaluru",
    rating: 5,
    text: "Excellent service by Navaneeth and team, got my prints within 2 days. Very smooth printing for jewel designs, which was very beneficial for me. Didn't spend any time for sanding — just sprayed on some primer and it was smooth enough to go!",
  },
  {
    name: "Chiru",
    role: "Product Designer, Bengaluru",
    rating: 5,
    text: "Extremely thankful to Mr. Navaneeth as he helped me a lot with my design and got my parts 3D printed and delivered in 1 day. Super happy about the product — pricing is also affordable compared to other 3D printing stores in Bangalore.",
  },
  {
    name: "TJ's Tech",
    role: "Local Guide · Architectural Model Maker",
    rating: 5,
    text: "I got my domes 3D printed for a 1:200 scaled architectural model of Lunar Habitat. Thanks to Navaneeth for helping me out with details in designing the model and delivering a fantastic result.",
  },
  {
    name: "VinU M",
    role: "Local Guide · Product Engineer",
    rating: 5,
    text: "Exceptional 3D printing shop! They provide outstanding customer care, realistic prices, and unparalleled support for all your needs. The team is not only energetic and enthusiastic but also goes above and beyond to help you succeed.",
  },
  {
    name: "Shreyas S",
    role: "Engineering Student, Bengaluru",
    rating: 5,
    text: "I had an exceptional experience with the 3D printing service provided by Mr. Girish. The customer service was responsive and helpful, guiding me through the process. The turnaround time was fast and the pricing competitive.",
  },
  {
    name: "Sundar Sriram",
    role: "Frequent Client · Multiple Projects",
    rating: 5,
    text: "Very professional team and has done prototypes in multiple projects, always meeting high quality and client expectations.",
  },
];
